import { GraphQLError } from "graphql/error/GraphQLError";
import { ApplicationError } from "@design-system";

export function isGraphQLErrors(
  value: ReadonlyArray<GraphQLError> | any
): value is ReadonlyArray<GraphQLError> {
  return value && Array.isArray(value);
}

export function translateGraphQLErrors(
  errors: ReadonlyArray<GraphQLError>,
  message?: string
): ApplicationError {
  if (errors.length > 0) {
    // TODO: Handle multiple errors
    const { message: gqlMessage } = errors[0];
    if (gqlMessage === "Internal Server Error") {
      return new ApplicationError("SERVER_ERROR", message);
    }
  }
  return new ApplicationError("SERVER_ERROR", message);
}
